import { SubscriptionAnalyseModal } from '../../../../styledComponents/Modals/SubscriptionAnalyseModal/SubscriptionAnalyseModal';
import { useAASubscriptionAnalyseModal } from './aASubscriptionAnalyseModal.hooks';

type AASubscriptionAnalyseModalProps = {
  onAnalyseSuccess?: () => void;
};

const AASubscriptionAnalyseModal = ({
  onAnalyseSuccess,
}: AASubscriptionAnalyseModalProps) => {
  const {
    isSubscriptionAnalyseLoading,
    isSubscriptionMembershipInProgress,
    handleSubmit,
    initialValues,
    handleCancel,
    totalMemberships,
  } = useAASubscriptionAnalyseModal(onAnalyseSuccess);
  return (
    <SubscriptionAnalyseModal
      isSubscriptionAnalyseLoading={isSubscriptionAnalyseLoading}
      isSubscriptionMembershipInProgress={isSubscriptionMembershipInProgress}
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      totalMemberships={totalMemberships}
    />
  );
};

export default AASubscriptionAnalyseModal;
